// Styles
import "../sass/main.scss";

// Images.
import "../img/picto-1.svg";
import "../img/picto-2.svg";
import "../img/picto-3.svg";
import "../img/emsd-logo.svg";
import "../img/mysteel-logo.svg";
import "../img/favicon.ico";
import "../img/DSC07353_crop.jpg";

import "parsleyjs";
import LazyLoad from "vanilla-lazyload";
import "magnific-popup";

// Barba
import barba from "@barba/core";

// Parallax
//import Parallax from "parallax-js";

// import Swiper JS
import { Swiper, Autoplay, EffectFade, Pagination } from "swiper";

// Install modules
Swiper.use([Autoplay, EffectFade, Pagination]);

// Gsap
import gsap from "gsap";

// logomotive-scroll
import LocomotiveScroll from "locomotive-scroll";

(function ($) {
  "use strict";

  function debug(report) {
    console.log(report);
  }

  var scroll;
  var introAnimated = false;

  var isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };

  var loadingScreen = document.querySelector(".loading-screen");
  var loadingLogo = document.querySelector(".loading-logo");
  var loadingLogoPaths = document.querySelectorAll(".loading-logo path");
  var mainNavigation = document.querySelector(".header-navigation");
  var mobileOpener = jQuery(".mobile-toggler");
  var toggleBtn = document.querySelector(".mobile-toggler-btn");
  var mobileNavigation = document.querySelector(".header-navigation");
  var menuList = document.querySelector(".header-navigation ul");
  var menuItems = document.querySelectorAll(".header-navigation ul li");
  let showMenu = false;
  var vpwidth;

  barba.hooks.before(() => {
    document.querySelector("html").classList.add("is-transitioning");
  });
  barba.hooks.after(() => {
    document.querySelector("html").classList.remove("is-transitioning");
  });

  var spinning;

  barba.init({
    sync: true,
    transitions: [
      {
        name: "custom-transition",
        async once({ next }) {
          //next.namespace
          //handleCustomCursor();
          debug("Barba Once");
          smooth(next.container);
          await contentAnimation(next.container);
          set_current_menu_item(next);
        },
        async leave(data) {
          await pageTransitionIn();
          data.current.container.remove();

          // Clode menu if
          if (showMenu) {
            toggleBtn.classList.remove("open");
            mobileNavigation.classList.remove("open");
            menuList.classList.remove("open");
            menuItems.forEach((item) => item.classList.remove("open"));
            showMenu = false;
          }
        },
        async beforeEnter({ next }) {
          // destroy the previous scroll
          scroll.destroy();

          // init LocomotiveScroll regarding the next page
          smooth(next.container);
        },
        async enter({ next }) {
          await pageTransitionOut(next.container);

          set_current_menu_item(next);
          //smooth(next.container);
        },
      },
    ],
  });

  if (mobileOpener.length) {
    jQuery("body").on("tap click", ".mobile-toggler", function (e) {
      e.preventDefault();

      if (!showMenu) {
        toggleBtn.classList.add("open");
        mobileNavigation.classList.add("open");
        menuList.classList.add("open");
        menuItems.forEach((item) => item.classList.add("open"));
        showMenu = true;
      } else {
        toggleBtn.classList.remove("open");
        mobileNavigation.classList.remove("open");
        menuList.classList.remove("open");
        menuItems.forEach((item) => item.classList.remove("open"));
        showMenu = false;
      }

      /*
      mobileNavigation.is(":visible")
        ? (mobileNavigation.slideUp(450),
          mobileOpener.removeClass("qodef--opened"))
        : (mobileNavigation.slideDown({
            start: function () {
              $(this).css({
                display: "flex",
              });
            },
          }),
          mobileOpener.addClass("qodef--opened"));
      */
    });
  }

  function lazyLoading() {
    debug("lazyLoading");
    if (!document.querySelector(".js-lazy")) {
      return;
    }

    function logElementEvent(eventName, element) {
      console.log(Date.now(), eventName, element);
    }
    var callback_error = function (element) {
      logElementEvent("💀 ERROR", element);
      element.src =
        "https://via.placeholder.com/440x560/?text=Error+Placeholder";
    };
    var callback_finish = function () {
      logElementEvent("✔️ FINISHED", document.documentElement);
    };
    var callback_enter = function (element) {
      logElementEvent("✔️ Enter", element);
    };
    var callback_loading = function (element) {
      logElementEvent("✔️ Loading", element);
    };
    var callback_loaded = function (element) {
      logElementEvent("✔️ Loaded", element);
    };

    new LazyLoad({
      // container: document.querySelector("[data-scroll-container]"),
      elements_selector: ".js-lazy",
      // Assign the callbacks defined above
      // callback_enter: callback_enter,
      // callback_loading: callback_loading,
      callback_loaded: callback_loaded,
      callback_error: callback_error,
      callback_finish: callback_finish,
    });

    debug("lazyLoading", "lets go !");

    // new LazyLoad({
    //   elements_selector: ".js-lazy",
    // });
  }

  function Init_Swiper() {
    debug("InitSwiper");

    var hero = new Swiper(".swiper-hero", {
      //init: false,
      effect: "fade",
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      on: {
        init: function () {
          debug("swiper initialized");
        },
      },
    });

    var contentsliders = new Swiper(".swiper-works, .swiper-story", {
      slidesPerView: 1,
      spaceBetween: 20,
      mousewheel: false,
      freeMode: true,
      grabCursor: true,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: "auto",
          spaceBetween: 20,
        },
      },
    });
  }

  function smooth(container) {
    debug("smooth");
    var sscroll = container.querySelector("[data-scroll-container]");
    scroll = new LocomotiveScroll({
      el: sscroll,
      smooth: true,
      repeat: true,
    });

    let scrollEnded = false,
      navShadow = false;

    scroll.on("scroll", function (datas) {
      //console.log(datas);

      // Ajouter le shadow au menu si on scroll
      if (datas.scroll.y > 10) {
        $("#page-header").addClass("is-scrolling");
      } else {
        $("#page-header").removeClass("is-scrolling");
      }

      if (window.screen.height / 2 <= datas.scroll.y) {
        if (!scrollEnded) {
          scrollEnded = true;
          heroVideoStatus(scrollEnded);
          console.log(scrollEnded);
        }
      } else if (scrollEnded) {
        scrollEnded = false;
        heroVideoStatus(scrollEnded);
        console.log(scrollEnded);
      }
    });
  }

  function heroVideoStatus(status) {
    var vid = document.getElementById("HeroVideo");
    if (vid) {
      if (!status) {
        vid.play();
      } else {
        vid.pause();
      }
    }
  }

  function set_current_menu_item(next) {
    var menu = document.querySelector(".menu");
    var nextItem = menu.querySelector(`a[href="${next.url.href}"]`);
    debug(next);

    // Remove all actives elements
    var activeItems = menu.querySelector(".item-active");
    if (activeItems !== null) {
      activeItems.classList.remove("item-active");
    }

    // Add active element
    if (nextItem !== null) {
      nextItem.classList.add("item-active");
    }
  }

  function get_WiewportWidth() {
    debug("WPW");
    var vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    return vw;
  }

  // Function to add and remove the page transition screen
  function pageTransitionIn() {
    var transition;

    debug("desktop", get_WiewportWidth());

    transition = gsap
      .timeline()
      .set(loadingLogo, {
        scale: 1,
      })
      // .set(loadingScreen, { transformOrigin: 'bottom left'})
      // .to(loadingScreen, { duration: .5, scaleY: 1 })
      .to(loadingScreen, {
        duration: 0.3,
        scaleY: 1,
        transformOrigin: "bottom left",
      })
      .to(
        loadingLogo,
        {
          duration: 0.3,
          opacity: 1,
          y: 0,
          ease: "power2.in",
        },
        "-=0.2"
      )
      .from(
        loadingLogoPaths,
        {
          //duration: 0.1,
          opacity: 0,
          //y: -10,
          stagger: 0.05,
          ease: "power2.in",
        },
        "-=0.1"
      );

    // Scroll to top
    // scroll.scrollTo("top", 0, 200);

    // GSAP methods can be chained and return directly a promise
    // but here, a simple tween is enough
    return transition;
  }

  // Function to add and remove the page transition screen
  function pageTransitionOut(container) {
    // Scroll to top
    scroll.scrollTo("top", 0, 200);

    var transition;

    debug("desktop", get_WiewportWidth());
    // GSAP methods can be chained and return directly a promise
    transition = gsap
      .timeline({ delay: 0 }) // More readable to put it here
      .add("start") // Use a label to sync screen and content animation
      .to(loadingScreen, {
        duration: 0.3,
        scaleY: 0,
        skewX: 0,
        transformOrigin: "top left",
        ease: "power1.out",
      })
      .to(
        loadingLogo,
        {
          duration: 0.3,
          opacity: 0,
          //y: -50,
          transformOrigin: "center center",
          scale: 3,
          ease: "power2.out",
        },
        "-=0.3",
        "start"
      )
      .call(contentAnimation, [container], "start");

    return transition;
  }
  function MPInit() {
    let scrollEnded = false;

    // Magnific popup
    $(".play-btn").magnificPopup({
      disableOn: 700,
      type: "iframe",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
      callbacks: {
        open: function () {
          if (!scrollEnded) {
            scrollEnded = true;
            heroVideoStatus(scrollEnded);
            //console.log(scrollEnded);
          }
        },
        close: function () {
          scrollEnded = false;
          heroVideoStatus(scrollEnded);
          //console.log(scrollEnded);
        },
      },
    });
  }
  // Function to animate the content of each page
  function contentAnimation(container) {
    //debug(container)
    convertSVG();
    MPInit();
    InitFuncFormContact();
    lazyLoading();

    // Query from container
    //$(container.querySelector('.green-heading-bg')).addClass('show')
    // GSAP methods can be chained and return directly a promise
    return gsap
      .timeline()
      .from(container.querySelector(".is-animated"), {
        duration: 0.5,
        translateY: 10,
        opacity: 0,
        stagger: 0.4,
        ease: "power1.inOut",
      })
      .call(function () {
        debug("Benoui ok maintenant on init");
        Init_Swiper();
        //smooth(container);
      });
    //.from(mainNavigation, { duration: .5, translateY: -10, opacity: 0})
  }

  function delay(n) {
    n = n || 2000;
    return new Promise((done) => {
      setTimeout(() => {
        done();
      }, n);
    });
  }

  function convertSVG() {
    debug("convertSVG");
    jQuery("img.svg").each(function () {
      var $img = jQuery(this);
      var imgID = $img.attr("id");
      var imgClass = $img.attr("class");
      var imgURL = $img.attr("src");

      //debug(imgURL);
      jQuery.get(imgURL, function (data) {
        var $svg = jQuery(data).find("svg");

        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }
        $svg = $svg.removeAttr("xmlns:a");
        $svg = $svg.removeAttr("width");
        $svg = $svg.removeAttr("height");

        $img.replaceWith($svg);
      });
    });
  }

  function InitFuncFormContact() {
    debug("InitFuncFormContact");

    // Contact

    $("#contact-form").parsley();
    $("#contact-form").on("submit", function (e) {
      e.preventDefault();
      var t = $(this),
        o = t.find("#valid-form");
      t.parsley().validate(),
        (o.disabled = !0),
        (o.innerText = "Envoi..."),
        t.parsley().isValid() &&
          $.ajax({
            url: ajaxurl,
            data: $(this).serialize(),
            type: "POST",
            success: function (e) {
              console.log(e),
                $(".fields").fadeOut(200),
                setTimeout(function () {
                  $(".messages")
                    .addClass("alert alert-success")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  $(".messages").fadeIn();
                }, 300);
            },
            error: function (e) {
              console.log(e);
              $(".fields").fadeOut(200),
                setTimeout(function () {
                  $(".messages")
                    .addClass("alert alert-danger")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  $(".sub_error").css("opacity", "1");
                }, 300);
            },
          });
    });

    // jobs
    $("#job-form").parsley();
    $("#curiculum").on("change", function () {
      console.log($(this).val());
      //get the file name
      var fileName = $(this).val();
      //replace the "Choose a file" label
      $(".custom-file-label").html(fileName);
    });

    $("#job-form").on("submit", function (e) {
      e.preventDefault();
      var t = $(this),
        o = document.getElementById("valid-form");

      var file_data = $("#curiculum").prop("files")[0];

      var $form = jQuery(this);
      var formdata = window.FormData ? new FormData($form[0]) : null;
      formdata.append("file", file_data);
      var data = formdata !== null ? formdata : $form.serialize();

      console.log($form.serialize());

      var formData = new FormData($(this)[0]);
      formData.append("file", file_data);
      for (var pair of formData.entries()) {
        console.log(pair[0] + ", " + pair[1]);
      }

      t.parsley().validate(),
        (o.disabled = !0),
        (o.innerText = "Envoi..."),
        t.parsley().isValid() &&
          $.ajax({
            url: ajaxurl,
            cache: false,
            contentType: false,
            processData: false,
            //data: $(this).serialize(),
            data: formData,
            type: "POST",
            success: function (e) {
              console.log(e),
                $(".fields").fadeOut(200),
                setTimeout(function () {
                  $(".messages")
                    .addClass("alert alert-success")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  $(".messages").fadeIn();
                }, 300);
            },
            error: function (e) {
              $(".fields").fadeOut(200),
                setTimeout(function () {
                  $(".messages")
                    .addClass("alert alert-danger")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  $(".sub_error").css("opacity", "1");
                }, 300);
            },
          });
    });

    var formDataSuppoerted = function () {
      return !!("FormData" in window);
    };

    window.Parsley.addValidator("filemaxmegabytes", {
      requirementType: "string",
      validateString: function (value, requirement, parsleyInstance) {
        if (!formDataSuppoerted()) {
          return true;
        }

        var file = parsleyInstance.$element[0].files;
        var maxBytes = requirement * 1048576;

        if (file.length == 0) {
          return true;
        }

        return file.length === 1 && file[0].size <= maxBytes;
      },
      messages: {
        en: "Fichier trop volumineux. Maximum 2Mo.",
      },
    }).addValidator("filemimetypes", {
      requirementType: "string",
      validateString: function (value, requirement, parsleyInstance) {
        if (!formDataSuppoerted()) {
          return true;
        }

        var file = parsleyInstance.$element[0].files;

        if (file.length == 0) {
          return true;
        }

        var allowedMimeTypes = requirement.replace(/\s/g, "").split(",");
        return allowedMimeTypes.indexOf(file[0].type) !== -1;
      },
      messages: {
        fr: "Ce type de fichier n'est pas valide. Seulement les fichiers .pdf, .doc et .docx sont autorisés.",
      },
    });
  }

  if (isMobile.any()) {
    jQuery("body").removeClass("custom-cursor");
  }

  // Custom cursor
  function handleCustomCursor() {
    if (jQuery("body").hasClass("custom-cursor")) {
      var cursorInnerEl = document.querySelector(".circle-cursor--inner");
      var cursorOuterEl = document.querySelector(".circle-cursor--outer");
      var lastY,
        lastX = 0;
      var magneticFlag = false;

      // move
      window.onmousemove = function (event) {
        if (!magneticFlag) {
          cursorOuterEl.style.transform =
            "translate(" + event.clientX + "px, " + event.clientY + "px" + ")";

          /*Old code*/
          // cursorOuterEl.style.top = event.clientY + 'px';
          // cursorOuterEl.style.left = event.clientX + 'px';
        }
        cursorInnerEl.style.transform =
          "translate(" + event.clientX + "px, " + event.clientY + "px" + ")";

        /*Old code*/
        // cursorInnerEl.style.top = event.clientY + 'px';
        // cursorInnerEl.style.left = event.clientX + 'px';
        lastY = event.clientY;
        lastX = event.clientX;
      };

      // links hover
      jQuery("body").on("mouseenter", "a, .cursor-as-pointer", function () {
        cursorInnerEl.classList.add("cursor-link-hover");
        cursorOuterEl.classList.add("cursor-link-hover");
      });
      jQuery("body").on("mouseleave", "a, .cursor-as-pointer", function () {
        if (
          jQuery(this).is("a") &&
          jQuery(this).closest(".cursor-as-pointer").length
        ) {
          return;
        }
        cursorInnerEl.classList.remove("cursor-link-hover");
        cursorOuterEl.classList.remove("cursor-link-hover");
      });

      // additional hover cursor class
      jQuery("body").on("mouseenter", "[data-cursor-class]", function () {
        var cursorClass = jQuery(this).attr("data-cursor-class");
        // cursorInnerEl.classList.add(cursorClass);
        // cursorOuterEl.classList.add(cursorClass);

        if (cursorClass.indexOf("dark-color") != -1) {
          cursorInnerEl.classList.add("dark-color");
          cursorOuterEl.classList.add("dark-color");
        }

        if (cursorClass.indexOf("cursor-link") != -1) {
          cursorInnerEl.classList.add("cursor-link");
          cursorOuterEl.classList.add("cursor-link");
        }
      });
      jQuery("body").on("mouseleave", "[data-cursor-class]", function () {
        var cursorClass = jQuery(this).attr("data-cursor-class");
        if (cursorClass.indexOf("dark-color") != -1) {
          cursorInnerEl.classList.remove("dark-color");
          cursorOuterEl.classList.remove("dark-color");
        }

        if (cursorClass.indexOf("cursor-link") != -1) {
          cursorInnerEl.classList.remove("cursor-link");
          cursorOuterEl.classList.remove("cursor-link");
        }
      });

      // magnet elements
      jQuery("body").on(
        "mouseenter",
        ".cursor-magnet, .btn-round",
        function () {
          var $elem = jQuery(this);
          var scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;

          cursorOuterEl.style.transition = "all .2s ease-out";
          cursorOuterEl.style.transform =
            "translate(" +
            $elem.offset().left +
            "px, " +
            ($elem.offset().top - scrollTop) +
            "px" +
            ")";

          /*Old code*/
          // cursorOuterEl.style.top = ($elem.offset().top - scrollTop) + 'px';
          // cursorOuterEl.style.left = $elem.offset().left + 'px';
          cursorOuterEl.style.width = $elem.width() + "px";
          cursorOuterEl.style.height = $elem.height() + "px";
          cursorOuterEl.style.marginLeft = 0;
          cursorOuterEl.style.marginTop = 0;

          magneticFlag = true;
        }
      );

      jQuery("body").on(
        "mouseleave",
        ".cursor-magnet, .btn-round",
        ohioRemoveMagneticFromCursor
      );

      function ohioRemoveMagneticFromCursor() {
        cursorOuterEl.style.transition = null;
        cursorOuterEl.style.width = null;
        cursorOuterEl.style.height = null;
        cursorOuterEl.style.marginLeft = null;
        cursorOuterEl.style.marginTop = null;

        /*Old code*/
        // cursorOuterEl.style.top = lastY + 'px';
        // cursorOuterEl.style.left = lastX + 'px';

        magneticFlag = false;
      }

      // Custom leave trigger
      jQuery("body").on("ohio:cursor_mouseleave", function () {
        ohioRemoveMagneticFromCursor();

        cursorOuterEl.style.transform = cursorInnerEl.style.transform;

        cursorInnerEl.classList.remove("cursor-link-hover");
        cursorOuterEl.classList.remove("cursor-link-hover");
      });

      //iframe fix
      jQuery("body").on("mouseenter", "iframe", function () {
        cursorOuterEl.style.visibility = "hidden";
        cursorInnerEl.style.visibility = "hidden";
      });
      jQuery("body").on("mouseleave", "iframe", function () {
        cursorOuterEl.style.visibility = "visible";
        cursorInnerEl.style.visibility = "visible";
      });

      cursorInnerEl.style.visibility = "visible";
      cursorOuterEl.style.visibility = "visible";
    }
  }

  if (mobileOpener.length) {
    jQuery("body").on("tap click", ".mobile-header-opener", function (e) {
      e.preventDefault();
      mobileNavigation.is(":visible")
        ? (mobileNavigation.slideUp(450),
          mobileOpener.removeClass("qodef--opened"))
        : (mobileNavigation.slideDown(450),
          mobileOpener.addClass("qodef--opened"));
    });
  }

  jQuery(".js-magnet-link a").each(function () {
    var _this = jQuery(this);
    debug(_this);
    var this_magnet_vars = {
      bordr: _this.find(".js-magnet-link-border"),
      top: _this.offset().top,
      left: _this.offset().left,
      w: _this.width(),
      h: _this.height(),
      max_move: 2,
    };

    _this
      .on("mousemove", function (e) {
        var posx = 0;
        var posy = 0;
        if (!e) e = window.event;
        if (e.pageX || e.pageY) {
          posx = e.pageX;
          posy = e.pageY;
        } else if (e.clientX || e.clientY) {
          posx =
            e.clientX + body.scrollLeft + document.documentElement.scrollLeft;
          posy =
            e.clientY + body.scrollTop + document.documentElement.scrollTop;
        }

        posx -= this_magnet_vars.left;
        posy -= this_magnet_vars.top;

        var cx = posx - Math.ceil(this_magnet_vars.w / 2.0),
          cy = posy - Math.ceil(this_magnet_vars.h / 2.0);

        if (cx > this_magnet_vars.max_move) {
          cx = this_magnet_vars.max_move + cx * 0.1;
        } else if (cx < -1 * this_magnet_vars.max_move) {
          cx = -1 * (this_magnet_vars.max_move - cx * 0.1);
        }

        if (cy > this_magnet_vars.max_move) {
          cy = this_magnet_vars.max_move + cy * 0.1;
        } else if (cy < -1 * this_magnet_vars.max_move) {
          cy = -1 * (this_magnet_vars.max_move - cy * 0.1);
        }

        gsap.to(this_magnet_vars.bordr, {
          x: cx,
          y: cy,
          duration: 0.2,
          overwrite: true,
          ease: "power2.out",
        });
      })
      .on("mouseleave", function () {
        gsap.to(this_magnet_vars.bordr, {
          x: 0,
          y: 0,
          duration: 1,
          overwrite: true,
          ease: "power2.out",
        });
      });
  });
})(jQuery);

Parsley.addMessages("fr", {
  defaultMessage: "Cette valeur semble non valide.",
  type: {
    email: "Cette valeur n'est pas une adresse email valide.",
    url: "Cette valeur n'est pas une URL valide.",
    number: "Cette valeur doit être un nombre.",
    integer: "Cette valeur doit être un entier.",
    digits: "Cette valeur doit être numérique.",
    alphanum: "Cette valeur doit être alphanumérique.",
  },
  notblank: "Cette valeur ne peut pas être vide.",
  required: "Ce champ est requis.",
  pattern: "Cette valeur semble non valide.",
  min: "Cette valeur ne doit pas être inférieure Ã  %s.",
  max: "Cette valeur ne doit pas excéder %s.",
  range: "Cette valeur doit être comprise entre %s et %s.",
  minlength:
    "Cette chaîne est trop courte. Elle doit avoir au minimum %s caractères.",
  maxlength:
    "Cette chaîne est trop longue. Elle doit avoir au maximum %s caractères.",
  length: "Cette valeur doit contenir entre %s et %s caractères.",
  mincheck: "Vous devez sélectionner au moins %s choix.",
  maxcheck: "Vous devez sélectionner %s choix maximum.",
  check: "Vous devez sélectionner entre %s et %s choix.",
  equalto: "Cette valeur devrait être identique.",
});

Parsley.setLocale("fr");
